import React from 'react';
import injectSheet from 'react-jss';

const Emote = ({classes, iconSrc}) => {
    return (
        <div className={classes.memeContainer}>
            <img className={classes.meme} src={iconSrc}/>
        </div>
    )
};

const styles = theme => ({
    memeContainer: {
        flex: '0 0 80px',
        height: '100%',
        maxWidth: ' 100%',
        marginLeft: '2px',
        marginRight: '2px',
        alignItems: 'center',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        // background: 'red',
    },
    meme: {
        height: '60%',
    },
});

export default injectSheet(styles)(Emote);



// WEBPACK FOOTER //
// ./src/app/components/emotesBar/Emote.js